import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next'; import AttunedLogoAnimation from 'images/logo-attuned-white-animation.svg';
import './styles.scss';

const PreparingTip = ({
    tipText, textColor, isAnimate, isShowToolTip
}) => {
    return (
        <div className={ `preparing-tip-container ${ isShowToolTip ? 'prepare-tip-hide' : 'prepare-tip-show' }` }>
            <div className='preparing-tip-header'>
                <img className='logo-animation' src={ AttunedLogoAnimation } alt='attuned-logo-animation' />
                <h3 className={ `${ isAnimate ? 'animate-header-text' : 'header-text' }` }>
                    {i18n.t('engagement.preparing_a_communication_tip')}
                </h3>
            </div>
            <span
                className={ `${ isAnimate ? 'animate-tip-text' : 'tip-text' }` }
                style={ { color: textColor } }>
                {tipText}
            </span>
        </div>
    );
};

PreparingTip.propTypes = {
    tipText: PropTypes.string,
    textColor: PropTypes.string,
    isAnimate: PropTypes.bool,
    isShowToolTip: PropTypes.bool
};

export default PreparingTip;
